import { render } from "./HomeView.vue?vue&type=template&id=a8203776&scoped=true&ts=true"
import script from "./HomeView.vue?vue&type=script&lang=ts"
export * from "./HomeView.vue?vue&type=script&lang=ts"

import "./HomeView.vue?vue&type=style&index=0&id=a8203776&lang=less&scoped=true"

import exportComponent from "/home/npm/produce/project/yuanYaExam/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8203776"]])

export default __exports__